// Module
var code = "<template class=\"a-field a-blank\"> <require from=\"components/field/common/field-holder/field-holder\"></require> <field-holder> <input type=\"text\" class=\"a-field__input__input\" readonly=\"readonly\" disabled=\"disabled\"/> </field-holder> </template> ";
// Exports
export default code;